<template>
    <div class="max-w-xl 2xl:max-w-3xl">
        <div class="my-4" :class="showSuccess ? 'bg-teal-100 font-bold' : ''">
            <UiComponentTypography variant="subtitle" class-name="text-center">
                <span v-if="showSuccess" class="text-teal-600 p-4 flex items-center gap-2 rounded-md">
                    <UIcon name="i-solar-check-circle-line-duotone" class="w-6 h-6" />
                    درخواست شما با موفقیت ثبت شد، همکاران ما به زودی با شما در ارتباط خواهند بود
                </span>
            </UiComponentTypography>
        </div>
        <UForm class="p-4" :schema="schema" :state="state" @submit="onSubmit">
            <UtilsFormBuilder form-size="xs" class="flex-wrap" :data="form" v-model="state" />
            <div class="flex justify-between mt-4">
                <div class="cf-turnstile" :data-sitekey="siteKey" data-theme="light"></div>
                <UButton type="submit" :loading="loading" size="md">
                    <span>ارسال</span>
                </UButton>
            </div>
        </UForm>
    </div>
</template>

<script lang="ts" setup>
import type { IDynamicKey, IForm } from "~/libs/types/general";
import { object, string, type InferType } from "yup";
import type { FormSubmitEvent } from "#ui/types";
import contact from "~/libs/schemas/forms/contact.json";
import type { IUser } from "~/libs/types/api/user";
import { addPhoneMethod } from "~/libs/validations/yup";

// useHead({
//     script: [
//         {
//             src: "https://challenges.cloudflare.com/turnstile/v0/api.js",
//             defer: true,
//         },
//     ],
// });

addPhoneMethod();

const emits = defineEmits(["send-data", "change:type"]);

const user = useSanctumUser<IUser>();
const toast = useToast();

const siteKey = process.env.CLOUDFLARE_SITE_KEY;

const form: Ref<IForm<any>[]> = ref(contact as IForm<any>[]);

const loading = shallowRef(false);
const showSuccess = shallowRef(false);
const defaultState = {
    email: undefined,
    name: undefined,
    family: undefined,
    phone: undefined,
    message: undefined,
};
const state: IDynamicKey<string | undefined> = reactive({ ...defaultState });

onMounted(() => {
    if (user.value?.phone) state.email = user.value.phone;
    else if (user.value?.email) state.email = user.value.email;
    if (user.value?.name) state.name = user.value.name;
});

const schema = object({
    name: string(),
    family: string(),
    email: string(),
    phone: string().phone().required("وارد کردن این فیلد الزامی‌ست"),
    message: string().required("وارد کردن این فیلد الزامی‌ست"),
});

type Schema = InferType<typeof schema>;

function errorSubmit() {
    toast.add({
        icon: "i-solar-danger-triangle-bold-duotone",
        title: "مشکلی پیش آمد!",
        description: "خطا در ارسال اطلاعات، لطفا مجدد تلاش نمایید",
        timeout: 5000,
        color: "rose",
    });
}

async function onSubmit(event: FormSubmitEvent<Schema>) {
    if (event.data) {
        loading.value = true;
        fetchData("/contacts", {
            method: "POST",
            body: event.data,
            onRequestError() {
                errorSubmit();
                loading.value = false;
            },
            onResponse({ response }) {
                if (isResponseSuccessful(response.status)) {
                    Object.assign(state, defaultState);
                    showSuccess.value = true;
                }
            },
            onResponseError({ error }) {
                errorSubmit();
            },
        }).then(() => {
            loading.value = false;
        });
    }
}
</script>

<style scoped>
.bg-image {
    background-image: url("https://static.northland-co.com/images/theme/bg-mobile-min.jpg");
    @apply bg-cover bg-center bg-no-repeat;
}

@screen xl {
    .bg-image {
        background-image: url("https://static.northland-co.com/images/theme/bg-min.jpg");
    }
}
</style>
